import { render, staticRenderFns } from "./TravelArea.vue?vue&type=template&id=0056eae5&"
import script from "./TravelArea.vue?vue&type=script&lang=js&"
export * from "./TravelArea.vue?vue&type=script&lang=js&"
import style0 from "./TravelArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelArea.vue"
export default component.exports